export default "__VITE_ASSET__5c6y5_mr__"